import { Phone, Mail } from "lucide-react";
import WhatsAppIcon from "./icons/WhatsAppIcon";
import { BUSINESS } from "../lib/business";

export default function MobileCallBar() {
    return (
        <div
            data-testid="mobile-call-bar"
            className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] grid grid-cols-3"
        >
            <a
                href={`tel:${BUSINESS.phoneTel}`}
                data-testid="mobilebar-call-cta"
                className="flex items-center justify-center gap-2 py-4 bg-amber-600 text-white font-semibold text-sm"
            >
                <Phone className="w-5 h-5" />
                Call
            </a>
            <a
                href={BUSINESS.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobilebar-whatsapp-cta"
                className="flex items-center justify-center gap-2 py-4 bg-[#25D366] text-white font-semibold text-sm"
            >
                <WhatsAppIcon className="w-5 h-5" />
                WhatsApp
            </a>
            <a
                href={`mailto:${BUSINESS.email}`}
                data-testid="mobilebar-email-cta"
                className="flex items-center justify-center gap-2 py-4 bg-slate-900 text-white font-semibold text-sm"
            >
                <Mail className="w-5 h-5" />
                Email
            </a>
        </div>
    );
}
